import { render } from "./SimpleLoader.vue?vue&type=template&id=0b73de9c&scoped=true"
import script from "./SimpleLoader.vue?vue&type=script&lang=js"
export * from "./SimpleLoader.vue?vue&type=script&lang=js"

import "./SimpleLoader.vue?vue&type=style&index=0&id=0b73de9c&scoped=true&lang=css"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b73de9c"]])

export default __exports__